import {createHelpers, mapFields} from 'vuex-map-fields';
import {errorOutput} from "../../helpers/errorOutput";
import {__t} from "../../helpers/translate";
import {PromiseWorker} from "../../helpers/promiseWorker";
import {getErrorTextResponse} from "../../helpers/getErrorTextResponse";
import {useToast} from 'vue-toastification';

const toast = useToast();

const {getAggregatorsField, updateAggregatorsField} = createHelpers({
    getterType: 'getAggregatorsField',
    mutationType: 'updateAggregatorsField',
});


const state = {
    aggregatorsList: [],
    aggregatorsDeliveriesList: [],
    errorMessageAggregators: '',
    aggregatorLocations: [],
    activeAggregator: {
        id: 0,
        name: '',
        type: '',
        human_name: '',
        icon: ''
    },
    activeAggregatorLocationsId: [],
    configApi: {},
    countAllSelectLocations: 0,
    countAggregatorsSelectLocations: 0,
    allSelectLocationsId: [],
    isLoadLocationsAggregator: false,
    aggregatorsLocationsAllList: [],
}

const actions = {
    async ACTIVE_AGGREGATORS_LIST({commit}, params) {
        try{
            let urlApi = '';
            if (params.onlySelectLocations) {
                urlApi = '/internal/aggregators/active/select';
            } else {
                urlApi = '/internal/aggregators/active';
            }
            const {data} = await $api.get(urlApi);
            if (data) {
                commit('setAggregatorsList', data);
            } else {
                errorOutput(__t('O.FAILED_GET_INFORMATION'), data, params.actionName);
            }
        } catch (err){
            errorOutput(__t('O.FAILED_GET_INFORMATION'), err, params.actionName);
        }
    },
    STATE_LOAD_LOCATIONS_AGGREGATOR({commit}, stateLoad) {
        commit('stateLoadLocationsAggregator', stateLoad);
    },
    SET_ACTIVE_AGGREGATOR({commit}, activeAggregator) {
        if (activeAggregator.type_data === 'aggregator') {
            $store.dispatch('aggregators/STATE_LOAD_LOCATIONS_AGGREGATOR', true);
        } else if (activeAggregator.type_data === 'delivery') {
            $store.dispatch('couriers/STATE_LOAD_LOCATIONS_DELIVERY', true);
        }
        commit('setActiveAggregator', activeAggregator);
    },
    async AGGREGATOR_LOCATIONS({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'aggregatorLocations',
                url: '/internal/aggregators/{aggregatorId}/locations',
                paramsUrl:
                    {
                        aggregatorId: params.aggregatorId
                    },
                method: 'GET',
                body: null,
            },
            {
                requestName: 'aggregatorLocationsSelectId',
                url: '/internal/aggregator/{aggregatorId}/locations/id/select',
                paramsUrl:
                    {
                        aggregatorId: params.aggregatorId
                    },
                method: 'GET',
                body: null,
            },
        )

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            params.results = results;
            const errorsList = requestsPromises.getErrorsResponses(results);
            if(errorsList.length > 0){
                errorOutput(__t('O.FAILED_ADD_LOCATION_LIST_INACTIVE'), JSON.stringify(errorsList), params.actionName);
            }
            commit('aggregatorLocations', params);
        } catch (err) {
            errorOutput(__t('O.FAILED_ADD_LOCATION_LIST_INACTIVE'), err, params.actionName);
        }
    },
    GET_DATA_ACTIVE_LOCATIONS_ID({commit}, params) {
        $api.get('/internal/aggregator/' + params.aggregatorId + '/locations/id/select')
            .then(resp => {
                if (resp.data) {
                    commit('getDataActiveLocationsId', resp.data);
                } else {
                    errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), resp, params.actionName);
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), err, params.actionName);
            })
    },
    GET_ALL_SELECT_LOCATIONS_ID({commit}, params) {
        $api.get('/internal/aggregators/locations/id/select')
            .then(resp => {
                if (resp.data) {
                    commit('getAllSelectLocationsId', resp.data);
                } else {
                    errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), resp, params.actionName);
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_GET_INFORMATION_ON_ACTIVE_LOCATIONS'), err, params.actionName);
            })
    },

   async ADD_ACTIVE_LOCATION({commit}, params) {
        try{
            const resp = await $api.put('/internal/aggregator/' + params.groupId + '/location/' + params.locationId + '/select',
                params.data)
            if (resp.status && resp.status === 200) {
                commit('addActiveLocation');
            } else {
                errorOutput(__t('O.FAILED_ADD_LOCATION_ACTIVE'), resp, params.actionName);
            }
        } catch (err){
            errorOutput(__t('O.FAILED_ADD_LOCATION_ACTIVE'), err, params.actionName);
        }
    },
    async REMOVE_ACTIVE_LOCATION({commit}, params) {
        try{
            const resp = await $api.delete('/internal/aggregator/' + params.groupId + '/location/' + params.locationId + '/select',
                params.data)
            if (resp.status && resp.status === 200) {
                commit('removeActiveLocation', params);
            } else {
                errorOutput(__t('O.FAILED_REMOVE_LOCATION_INACTIVE'), data, params.actionName);
            }
        } catch (err){
            errorOutput(__t('O.FAILED_REMOVE_LOCATION_INACTIVE'), err, params.actionName);
        }
    },
    async ADD_ACTIVE_LOCATION_LIST({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'Add active location',
                url: '/internal/aggregator/{aggregatorId}/locations/id/select/list',
                paramsUrl:
                    {
                        aggregatorId: params.id
                    },
                method: 'PUT',
                body: params.restList,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('addActiveLocationList', {results: results, errorsList: errorsList, actionName: params.actionName});
        } catch (err) {
            errorOutput(__t('O.FAILED_ADD_LOCATION_LIST_INACTIVE'), err, params.actionName);
        }
    },
    async REMOVE_ACTIVE_LOCATION_LIST({commit}, params) {
        const requests = [];
        requests.push(
            {
                requestName: 'Remove active location',
                url: '/internal/aggregator/{aggregatorId}/locations/id/select/list',
                paramsUrl:
                    {
                        aggregatorId: params.id
                    },
                method: 'DELETE',
                body: params.restList,
            })

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            const errorsList = requestsPromises.getErrorsResponses(results);
            commit('removeActiveLocationList', {
                results: results,
                errorsList: errorsList,
                actionName: params.actionName
            });
        } catch (err) {
            errorOutput(__t('O.FAILED_REMOVE_LOCATION_LIST_INACTIVE'), err, params.actionName);
        }
    },
    GET_ALL_SELECT_LOCATIONS_COUNT({commit}, params) {
        $api.get('/internal/locations/select/count')
            .then(resp => {
                if (resp.data) {
                    commit('getAllSelectLocationsCount', resp.data);
                } else {
                    errorOutput(__t('O.NOT_CALCULATED_ALL_ACTIVE_LOCATIONS'), resp, params.actionName);
                }
            })
            .catch(err => {
                errorOutput(__t('O.NOT_CALCULATED_ALL_ACTIVE_LOCATIONS'), err, params.actionName);
            })
    },
    GET_AGGREGATORS_SELECT_LOCATIONS_COUNT({commit}, params) {
        $api.get('/internal/locations/select/count')
            .then(resp => {
                if (resp.data) {
                    commit('getAggregatorsSelectLocationsCount', resp.data);
                } else {
                    errorOutput(__t('O.NOT_CALCULATED_ALL_ACTIVE_LOCATIONS'), resp, params.actionName);
                }
            })
            .catch(err => {
                errorOutput(__t('O.NOT_CALCULATED_ALL_ACTIVE_LOCATIONS'), err, params.actionName);
            })

    },
    UPDATE_MENU_SELECT_LOCATIONS_COUNT({commit}) {
        $api.get('/internal/aggregators/locations/select/count')
            .then(resp => {
                if (resp.data) {
                    commit('updateMenuSelectLocationsCount', resp.data);
                } else {
                    errorOutput(__t('O.NOT_RENEW_CALCULATED_LOCATIONS_MENU'), resp, 'updateMenuSelectLocationsCount');
                }
            })
            .catch(err => {
                errorOutput(__t('O.NOT_RENEW_CALCULATED_LOCATIONS_MENU'), err, 'updateMenuSelectLocationsCount');
            })
    },
    CHANGE_LOCATIONS_STATUS({commit}, params) {
        $api.patch('/internal/aggregators/locations/' + params.location.id.toString() + '/status/' + params.status.toString())
            .then(resp => {
                if (resp.data) {
                    params.resp = resp.data;
                    commit('changeLocationsStatus', params);
                } else {
                    errorOutput(__t('O.FAILED_CHANGE_LOCATION_STATUS'), resp, params.actionName);
                }
            })
            .catch(err => {
                errorOutput(__t('O.FAILED_CHANGE_LOCATION_STATUS'), err, params.actionName);
            })
    },

    async CHANGE_LOCATIONS_STATUS_LIST({commit}, params) {

        const requests = [];
        // params.locations.forEach(location => {
        //     requests.push($api.patch('/internal/aggregators/locations/' + location.id.toString() + '/status/' + params.status.toString()));
        // });

        params.locations.forEach(location => {
            requests.push(
                {
                    requestName: location.title,
                    requestObject: location,
                    url: '/internal/aggregators/locations/{locationId}/status/{status}',
                    paramsUrl:
                        {
                            locationId: location.id.toString(),
                            status: params.status.toString(),
                        },
                    method: 'PATCH',
                    body: null,
                },
            )
        });

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            params.results = results;
            const errorsList = requestsPromises.getErrorsResponses(results, true);
            if(errorsList.length > 0){
                errorOutput(__t('O.REQUEST_FAILED_CHANGE_LOCATIONS_STATUS'), JSON.stringify(errorsList), params.actionName);
            }
            commit('changeLocationsStatusList', params);
        } catch (err) {
            errorOutput(__t('O.REQUEST_FAILED_CHANGE_LOCATIONS_STATUS'), err, params.actionName);
        }
    },
    async STOP_LIST_ACTION({commit}, params) {
        let productsStopList = [];
        if (params.productSelect) {
            productsStopList = [{
                "uniq_id": params.productSelect.product.uniq_id,
                "id": params.productSelect.product.id,
                "title": params.productSelect.product.title,
                "amount": 0,
                "action": params.action
            }]
        } else {
            productsStopList = $store.getters["stop_list/getSelectProductsStopList"]
                .map(item => {
                    if (item.product) {
                        return {
                            "uniq_id": item.product.uniq_id,
                            "id": item.product.id,
                            "title": item.product.title,
                            "amount": 0,
                            "action": params.action
                        }
                    }
                });
        }
        const productsRequest = {products: productsStopList};

        const requests = [];
        params.selectLocations.forEach(location => {
            requests.push(
                {
                    requestName: location.title,
                    url: '/internal/locations/{locationId}/stop_list/{action}',
                    paramsUrl:
                        {
                            locationId: location.id,
                            action: params.action,
                        },
                    method: 'POST',
                    body: productsRequest,
                },
            )
        });

        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            params.results = results;
            const errorsList = requestsPromises.getErrorsResponses(results, true);
            if(errorsList.length > 0){
                errorOutput(__t('O.REQUEST_FAILED_STOP_LIST_ACTION'), JSON.stringify(errorsList), params.actionName);
            }
            commit('stopListAction', params);
        } catch (err) {
            errorOutput(__t('O.REQUEST_FAILED_STOP_LIST_ACTION'), err, params.actionName);
        }
    },
    async ACTIVE_AGGREGATORS_DELIVERIES_LIST({commit}, params) {
        let urlAggregators = '/internal/aggregators/active';
        let urlDeliveries = '/internal/delivery/active';
        if (params.onlySelectLocations) {
            urlAggregators = '/internal/aggregators/active/select';
            urlDeliveries = '/internal/delivery/active/select';
        }
        const requests =
            [
                {
                    requestName: 'aggregators',
                    url: urlAggregators,
                    paramsUrl: null,
                    method: 'GET',
                    body: null,
                },
                {
                    requestName: 'deliveries',
                    url: urlDeliveries,
                    paramsUrl: null,
                    method: 'GET',
                    body: null,
                },
            ]
        const requestsPromises = new PromiseWorker($api, requests, EventBus);
        try {
            const results = await requestsPromises.executeAsyncRequests();
            commit('activeAggregatorsDeliveriesList', {results: results, actionName: params.actionName});
        } catch (err) {
            errorOutput(__t('O.ERROR_OPERATION_GET_AGGREGATORS_DELIVERIES_ACTIVE'), err, params.actionName);
        }
    },

}

const mutations = {
    updateAggregatorsField,
    stateLoadActiveAggregatorsList(state, stateLoad) {
        state.isLoadActiveAggregatorsList = stateLoad;
    },
    stateLoadSelectAggregatorsList(state, stateLoad) {
        state.isLoadSelectAggregatorsList = stateLoad;
    },
    stateLoadLocationsAggregator(state, stateLoad) {
        state.isLoadLocationsAggregator = stateLoad;
    },
    stopListAction(state, params) {
        $store.dispatch('stop_list/CLEAR_SEARCH_STOP_LIST_REST');
        $store.dispatch('stop_list/CLEAR_SEARCH_STOP_LIST_FAST');
        toast.success(`${__t('PS.THE_OPERATION_WAS_COMPLETED_SUCCESSFULLY')}`);
        EventBus.$emit('stop_list_action', params.actionName);
    },
    setAggregatorsList(state, resp) {
        if (resp.status === 'operation_success') {
            state.aggregatorsList = resp.data;
        } else {
            state.errorMessageAggregators = 'error data aggregator list'
        }
        state.aggregatorsList.forEach((item, index) => {
            item.isSelect = index === 0;
            item.type_data = 'aggregator';
        })
        EventBus.$emit('active_aggregators_list');
    },
    setActiveAggregator(state, activeAggregator) {
        state.activeAggregator = activeAggregator;
    },
    aggregatorLocations(state, params) {
        state.aggregatorLocations = [];
        params.results.forEach(res => {
            if (res.error) {
                return;
            }
            if(res.requestName === 'aggregatorLocations'){
                if(res.result && res.result.data) {
                    state.aggregatorLocations = res.result.data;
                }
            } else if(res.requestName === 'aggregatorLocationsSelectId'){
                if(res.result && res.result.data) {
                    state.activeAggregatorLocationsId = res.result.data;
                }
            }
        })

        const loc = state.aggregatorLocations.map(item => item.id);

        if(params.onlySelectLocations) {
            state.aggregatorLocations = state.aggregatorLocations.filter(item => state.activeAggregatorLocationsId.includes(item.id));
        }

        mutations.changeStateActiveLocations(state);
        state.aggregatorLocations.forEach(item => {
            item.status = 'online';
            item.isCheck = false;
        });
        if(params.errorsList){
            errorOutput(__t('O.ERROR_GET_DATA_AGGREGATOR_LOCATIONS_LIST'), params.errorsList);
        }
        $store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT');
        EventBus.$emit('load_aggregator_locations');
    },
    changeStateActiveLocations(state) {
        if (Array.isArray(state.activeAggregatorLocationsId)) {
            state.aggregatorLocations.forEach(item => {
                item.isSelect = state.activeAggregatorLocationsId.includes(item.id);
            })
        }
    },
    addActiveLocation(state) {
        $store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT');
        $store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_ID');
        EventBus.emit('change_active_location');
    },
    removeActiveLocation(state, params) {
        if (params.onlySelectLocations) {
            let index = state.aggregatorLocations.findIndex(item => item.id === params.locationId);
            state.aggregatorLocations.splice(index, 1);
        }
        $store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT');
        $store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_ID');
        EventBus.emit('change_active_location');
    },
    addActiveLocationList(state, params) {
        if (params.errorsList.length !== 0) {
            errorOutput(__t('O.OPERATION_NOT_COMPLETED'), JSON.stringify(params.errorsList), params.actionName);
        }
        $store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT');
        $store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_ID');
        EventBus.emit('change_active_location');
    },
    removeActiveLocationList(state, params) {
        if (params.errorsList.length !== 0) {
            errorOutput(__t('O.OPERATION_NOT_COMPLETED'), JSON.stringify(params.errorsList), params.actionName);
        }
        $store.dispatch('aggregators/UPDATE_MENU_SELECT_LOCATIONS_COUNT');
        $store.dispatch('aggregators/GET_ALL_SELECT_LOCATIONS_ID');
        EventBus.emit('change_active_location');
    },
    getDataActiveLocationsId(state, resp) {
        if (resp.status === 'operation_success') {
            state.activeAggregatorLocationsId = resp.data;
            mutations.changeStateActiveLocations(state);
        }
    },
    getAllSelectLocationsId(state, resp) {
        if (resp.status === 'operation_success') {
            state.allSelectLocationsId = resp.data;
            EventBus.$emit('get_all_active_locations_id');
        }
    },
    getAllSelectLocationsCount(state, resp) {
        if (resp.status === 'operation_success') {
            state.countAllSelectLocations = resp.data;
            EventBus.$emit('select_locations_count');
        }
    },
    getAggregatorsSelectLocationsCount(state, resp) {
        if (resp.status === 'operation_success') {
            state.countAllSelectLocations = resp.data;
            EventBus.$emit('select_aggregators_locations_count');
        }
    },
    updateMenuSelectLocationsCount(state, resp) {
        if (resp.status === 'operation_success') {
            state.countAggregatorsSelectLocations = resp.data;
            EventBus.emit('update_menu_select_locations_count');
            let params = {
                active_rest: state.countAggregatorsSelectLocations
            }
            $store.dispatch('user/UPDATE_MENU_MAIN_INFO', params);
        } else {
            errorOutput(__t('O.NOT_RENEW_CALCULATED_ACTIVE_LOCATIONS_MENU'), resp);
        }
    },
    changeLocationsStatus(state, params) {
        if (params.resp.status !== 'operation_success') {
            errorOutput(__t('O.ERROR_CHANGE_LOCATION_STATUS'), params.resp, params.actionName);
        } else {
            params.location.status = params.status;
        }
        EventBus.$emit('change_location_status', params);
    },
    changeLocationsStatusList(state, params) {
        params.results.forEach(item => {
            if(item.error){

            }
        });
        EventBus.$emit('change_location_status_list', params);
    },
    activeAggregatorsDeliveriesList(state, params) {
        state.aggregatorsDeliveriesList = [];
        params.results.forEach(res => {
            const errText = getErrorTextResponse(res);

            if (errText && errText !== '') {
                errorOutput(__t('O.ERROR_OPERATION_GET_AGGREGATORS_DELIVERIES_ACTIVE'), errText, params.actionName);
            } else {
                res.result.data.forEach(item => {
                    state.aggregatorsDeliveriesList.push(item);
                })
            }
        })
        EventBus.$emit('active_aggregators_delivery_list');
    },
}

const getters = {
    getAggregatorsField,
    selectProductsStopList: (state, getters, rootState, rootGetters) => {
        return rootState.stop_list.selectProductsStopList;
    },
    getAggregatorsList(state) {
        return state.aggregatorsList;
    },
    getErrorMessageAggregators(state) {
        return state.errorMessageAggregators;
    },
    getActiveAggregator(state) {
        return state.activeAggregator;
    },
    getAggregatorLocations(state) {
        return state.aggregatorLocations;
    },
    getActiveAggregatorLocationsId(state) {
        return state.activeAggregatorLocationsId;
    },
    getCountAllSelectLocations(state) {
        return state.countAllSelectLocations;
    },
    getCountAggregatorsSelectLocations(state) {
        return state.countAggregatorsSelectLocations;
    },
    getAggregatorsDeliveriesList(state) {
        return state.aggregatorsDeliveriesList;
    },
    getIsLoadLocationsAggregator(state) {
        return state.isLoadLocationsAggregator;
    },
    getAllSelectLocationsId(state) {
        return state.allSelectLocationsId;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

